export default __webpack_public_path__ + "static/Bruny-Island-431f85880da0feba21364e40c1f2b35f.jpg";